import { Link } from 'react-router';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-bg-surface border-t border-border" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Logo & Copyright */}
          <div className="flex flex-col items-center md:items-start gap-2">
            <span className="text-lg font-bold text-accent">LexAssist</span>
            <p className="text-sm text-text-tertiary">
              © {currentYear} LexAssist. Toate drepturile rezervate.
            </p>
          </div>

          {/* Links */}
          <nav aria-label="Navigare subsol">
            <ul className="flex flex-wrap items-center justify-center gap-6 text-sm list-none m-0 p-0">
              <li>
                <Link
                  to="/pricing"
                  className="text-text-secondary hover:text-text-primary transition-colors"
                >
                  Prețuri
                </Link>
              </li>
              <li>
                <Link
                  to="/checklist"
                  className="text-text-secondary hover:text-text-primary transition-colors"
                >
                  Checklist-uri
                </Link>
              </li>
              <li>
                <Link
                  to="/conformitate-fiscala"
                  className="text-text-secondary hover:text-text-primary transition-colors"
                >
                  Conformitate Fiscală
                </Link>
              </li>
              <li>
                <Link
                  to="/jurisprudenta"
                  className="text-text-secondary hover:text-text-primary transition-colors"
                >
                  Jurisprudență
                </Link>
              </li>
              <li>
                <Link
                  to="/api-docs"
                  className="text-text-secondary hover:text-text-primary transition-colors"
                >
                  API
                </Link>
              </li>
              <li>
                <Link
                  to="/termeni"
                  className="text-text-secondary hover:text-text-primary transition-colors"
                >
                  Termeni și condiții
                </Link>
              </li>
              <li>
                <Link
                  to="/confidentialitate"
                  className="text-text-secondary hover:text-text-primary transition-colors"
                >
                  Confidențialitate
                </Link>
              </li>
              <li>
                <Link
                  to="/cookie-uri"
                  className="text-text-secondary hover:text-text-primary transition-colors"
                >
                  Cookie-uri
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
}
